import { RuleProperties } from '@react-awesome-query-builder/mui';

import { isTemplatePlaceholder } from '@/types';
import { HasPhoneFilter } from '@/types/searchFilterTypes';
import { FilterMapper } from './filterMapperTypes';

export const PLACEHOLDER_PHONE_FILTER_LABEL = 'Contactable by phone filter';

export const HasPhoneMapper: FilterMapper = {
  checkIsIncomplete({ value }) {
    const isNoPhoneTypeSelected = value[0] === undefined;
    return isNoPhoneTypeSelected;
  },
  toFilter(props: RuleProperties): HasPhoneFilter {
    if (!props.value) throw new Error('Missing value');
    if (props.value.length !== 1) throw new Error('Invalid value. Expected array of length 1');

    const nestedValue = props.value[0];

    if (isTemplatePlaceholder(nestedValue)) {
      return { name: 'hasPhone', value: nestedValue };
    }

    if (typeof props.value[0] !== 'string') throw new Error('Invalid value. Expect single string');

    const mappedValue = (props.value[0] as unknown as string).toLowerCase();
    if (mappedValue !== 'any' && mappedValue !== 'mobile' && mappedValue !== 'landline')
      throw new Error('Invalid value');

    return { name: 'hasPhone', value: mappedValue } as HasPhoneFilter;
  },

  async fromFilter(filter: HasPhoneFilter) {
    if (isTemplatePlaceholder(filter.value)) {
      return {
        field: filter.name,
        operator: 'select_equals',
        value: [filter.value],
      };
    }

    return {
      field: filter.name,
      operator: 'select_equals',
      value: [filter.value],
    };
  },
};
